import * as yup from 'yup';

export const assignValidationSchema = yup.object().shape({
  sections: yup
    .array()
    .of(
      yup.object().shape({
        sectionId: yup.mixed().nullable().required('Section is required.'),
        due: yup.string().required('Due date is required.')
      })
    )
    .min(1, 'At least 1 section is required.')
});

const stepperAssignmentValidationSchema = yup.object().shape({
  assignmentName: yup.string().required('Assignment name is required'),
  description: yup.string(),
  tasks: yup.array().of(
    yup.object().shape({
      standards: yup.array(),
      count: yup.number().min(1, 'Must have at least 1 page')
    })
  ),
  rubric: yup.string().required('Please select a rubric'),
  pageCount: yup
    .string()
    .required('Number of pages is required')
    .test(
      'valid-pages',
      'Must be at least 1 page',
      (value) => value && parseInt(value) > 0
    ),
  pageType: yup.string().required('Please select page type'),
  attachments: yup.array()
});

export const getValidationSchema = ({ isMathAssignment }) => {
  if (isMathAssignment) {
    return yup.object().shape({
      assignmentName: yup.string().required('Assignment name is required'),
      description: yup.string(),
      tasks: yup.array().of(
        yup.object().shape({
          standards: yup.array(),
          count: yup.number().min(1, 'Must have at least 1 page')
        })
      ),
      rubric: yup.string().required('Please select a rubric'),
      pageCount: yup
        .string()
        .required('Number of pages is required')
        .test(
          'valid-pages',
          'Must be at least 1 page',
          (value) => value && parseInt(value) > 0
        ),
      pageType: yup.string().required('Please select page type'),
      attachments: yup
        .array()
        .min(1, 'Attachment is required')
        .max(1, 'Upload one attachment. Either an image or pdf with images')
        .required('This field is required')
    });
  }

  return stepperAssignmentValidationSchema;
};
